// extracted by mini-css-extract-plugin
export default {"selectable":"editingStyles_selectable__ij1dx","scrollableOverflow":"editingStyles_scrollableOverflow__sN5rJ","star":"editingStyles_star__pUXHd"};